import {
  COLOR_BACKGROUND_INVERSE,
  COLOR_BACKGROUND_PRIMARY,
  COLOR_BLUE_700,
  COLOR_BLUE_900,
  COLOR_GREEN_500,
  COLOR_GREEN_600,
  COLOR_GREEN_900,
  COLOR_NEUTRAL_200,
  COLOR_NEUTRAL_400,
  COLOR_NEUTRAL_500_A,
  COLOR_NEUTRAL_600_A,
  COLOR_NEUTRAL_700,
  COLOR_PINK_600
} from '@alltrails/denali/tokens';
import { createPinMarker } from './svgMarkerComponents';

type GetFillArgs = {
  isActive?: boolean;
  isClosed?: boolean;
  isCustomRoute?: boolean;
  isSaved?: boolean;
  isCompleted?: boolean;
  hasNewPinsExperiment?: boolean;
  isViewed?: boolean;
};

const getFill = ({
  isActive = false,
  isClosed = false,
  isCustomRoute = false,
  isSaved = false,
  isCompleted = false,
  hasNewPinsExperiment = false,
  isViewed = false
}: GetFillArgs) => {
  if (isClosed) {
    if (hasNewPinsExperiment && !isActive) {
      return COLOR_NEUTRAL_400;
    } else if (!hasNewPinsExperiment && isActive) {
      return COLOR_GREEN_600;
    }
  }
  if (isCustomRoute) {
    return isActive ? COLOR_BLUE_900 : COLOR_BLUE_700;
  }
  if (isSaved && !isActive) {
    return COLOR_PINK_600;
  }
  if (isCompleted && !isActive) {
    return hasNewPinsExperiment ? COLOR_GREEN_500 : COLOR_NEUTRAL_700;
  }
  if (isActive) {
    return hasNewPinsExperiment ? COLOR_BACKGROUND_INVERSE : COLOR_GREEN_600;
  }
  if (isViewed) {
    return COLOR_NEUTRAL_200;
  }

  return hasNewPinsExperiment ? COLOR_BACKGROUND_PRIMARY : COLOR_GREEN_900;
};

type CreateTrailPinSvgProps = {
  imageName: string;

  trailCount: number;

  isActive?: boolean;

  isClosed?: boolean;

  isCustomRoute?: boolean;
  isSaved?: boolean;
  isCompleted?: boolean;
  isCollapsed?: boolean;
  hasNewPinsExperiment?: boolean;
  isViewed?: boolean;
};

const createTrailPinSvg = ({
  imageName,
  trailCount,
  isActive = false,
  isClosed = false,
  isCustomRoute = false,
  isSaved = false,
  isCompleted = false,
  isCollapsed = false,
  hasNewPinsExperiment = false,
  isViewed = false
}: CreateTrailPinSvgProps) => {
  const innerFill = getFill({ isActive, isClosed, isCustomRoute, isSaved, isCompleted, hasNewPinsExperiment, isViewed });
  const closedTextFill = isClosed && !isActive ? COLOR_NEUTRAL_700 : undefined;
  const getBorderFill = () => {
    if (hasNewPinsExperiment && isCollapsed && isViewed) {
      return COLOR_NEUTRAL_500_A;
    }
    if (hasNewPinsExperiment && isCollapsed && !isSaved && !isCompleted && !isClosed) {
      return COLOR_NEUTRAL_600_A;
    }
    return undefined;
  };
  const borderFill = getBorderFill();

  return createPinMarker({
    imageName,
    innerFill,
    borderFill,
    dashFill: closedTextFill,
    numberContent: trailCount > 1 && !isCustomRoute ? trailCount : undefined,
    renderInnerDot: !isClosed && trailCount === 1,
    renderInnerDash: isClosed && trailCount === 1,
    textFill: closedTextFill,
    renderInnerHeart: isSaved && trailCount === 1,
    renderCheckmark: isCompleted && trailCount === 1,
    isCollapsed,
    hasNewPinsExperiment
  });
};

export default createTrailPinSvg;
